module.exports = __webpack_public_path__ + "static/intro-1153385188.b181cced.jpg";